module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yqbC7F/tc-custom/9781609253936.jpg?1726617332214",
      "alt": "This image is the cover for the book Luminaries, Seminars in Psychological Astrology"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Luminaries, Seminars in Psychological Astrology\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From the founders of the Centre for Psychological Astrology, the third seminar in their series for practitioners discusses sun and moon signs.")]), _c('br'), _c('br'), _vm._v("Liz Greene and Howard Sasportas, psychologists, astrologers and founders of the Centre for Psychological Astrology in London continue their series of seminars with "), _c('i', [_vm._v("The Luminaries. ")]), _vm._v("In this book, they discuss the mythology and psychology of the Moon, showing its relevance as a significator of relationships. In addition, the authors explore in depth the correspondence between the Sun and the development of consciousness. "), _c('i', [_vm._v("The Luminaries ")]), _vm._v("also includes a chapter on the lunation cycle.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Liz Greene, Howard Sasportas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Liz Greene is the cofounder of the Centre for Psychological Astrology in London and a contributor to the most respected astrology site on the web: www.astro.com, as well as a regular contributor to Astrodientst.com. She is the author of Astrology for Lovers and Relating: An Astrological Guide to Living with Others on a Small Planet. Greene currently resides in Zurich, Switzerland.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Red Wheel/Weiser, LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0